export const PIN_DARK = "/assets/images/pin-dark.png";
export const PIN_WHITE = "/assets/images/pin-white.png";
export const PIN_DARK_MARKER_CLUSTERER =
    "/assets/images/pin-dark-marker-clusterer.png";
export const PIN_WHITE_MARKER_CLUSTERER =
    "/assets/images/pin-white-marker-clusterer.png";
